import React, { useContext } from 'react';
import { useParams } from 'react-router';
import { fetchSegmentsQuery, saveSegmentsQuery } from './service/case-segment.queries';
import { FormikProvider, useFormik } from 'formik';
import { caseSegmentsInitialData } from 'app/edozvola/cases/case-segment/model/case-segment.model';
import { caseSegmentValidationSchema } from 'app/edozvola/cases/case-segment/model/case-segment.schema';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { Alert, Col, Row } from 'reactstrap';
import { Label, TextArea } from 'edozvola-frontend-lib/dist/ui';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import { useDispatch } from 'react-redux';
import './case-segments.scss';
import { Loader } from 'app/shared/loader/loader';
import FormikValueObserver from 'app/shared/formik-observer/formik-observer';
import { getCaseContext } from 'app/shared/util/context-util';
import { AutosizeTextArea } from 'app/shared/autosize-text-area/autosize-text-area';

const CaseSegment = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const { sidebarItemPair } = getCaseContext();
  const dispatch = useDispatch();

  const { data: caseSegments, isLoading: caseSegmentsLoading } = fetchSegmentsQuery(uuid);

  const formik = useFormik({
    initialValues: caseSegments ? (caseSegments.segments.length === 0 ? caseSegmentsInitialData : caseSegments) : caseSegmentsInitialData,
    onSubmit: values => saveCaseSegments(values),
    validationSchema: caseSegmentValidationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });

  const { mutate: saveCaseSegments, isPending: isCaseSegmentsSaving } = saveSegmentsQuery(uuid, formik.resetForm);

  const addNewSegment = () => {
    formik.setFieldValue('segments', [
      ...formik.values.segments,
      {
        mark: `E-${formik.values.segments.length + 1}`,
        description: '',
      },
    ]);
  };

  const deleteSegment = (indexToDelete: number) => {
    formik.setFieldValue(
      'segments',
      formik.values.segments
        .filter((segment, segmentIndex) => segmentIndex !== indexToDelete)
        .map((segment, segmentIndex) => ({
          ...segment,
          mark: `E-${segmentIndex + 1}`,
        })),
    );
  };

  return (
    <>
      {caseSegmentsLoading && <Loader />}
      {!caseSegmentsLoading && (
        <FormikProvider value={formik}>
          <FormikValueObserver
            onChange={dirty => {
              if (dirty.dirty) {
                dispatch(setFormChanged(true));
              } else {
                dispatch(initCaseFormChange());
              }
            }}
          />
          <div className={'d-flex justify-content-between flex-column gap-3'}>
            <div className="form-header">Etažiranje</div>
            {formik.values.segments.length === 0 && <Alert color="info" className="uniform-width">{'Nema dodanih etaža'}</Alert>}
            {formik.values.segments.map((segment, index) => (
              <div className={'d-flex gap-3'} key={index}>
                <Col md={6}>
                  <Label labelText={`E-${index + 1}`} />
                  <AutosizeTextArea
                    disabled={sidebarItemPair?.readOnly}
                    value={segment.description}
                    maxLength={1024}
                    error={!sidebarItemPair?.readOnly && formik.errors.segments && formik.errors.segments[index] ? formik.errors.segments[index]['description'] : ''}
                    onChange={event => formik.setFieldValue(`segments.[${index}].description`, event.target.value)}
                  />
                </Col>
                {!sidebarItemPair?.readOnly &&
                  <Col md={2}>
                    <Button
                      className={'delete-segment'}
                      prependIcon={'trash'}
                      color={'secondary'}
                      size={'lg'}
                      onClick={() => deleteSegment(index)}
                    />
                  </Col>
                }
              </div>
            ))}
          </div>
          {!sidebarItemPair?.readOnly && (
            <Row className={'mt-4'}>
              <Col md={4}>
                <Button
                  disabled={!formik.isValid}
                  label={'Dodaj etažu'}
                  color={'info'}
                  size={'lg'}
                  prependIcon={'plus'}
                  onClick={addNewSegment}
                />
              </Col>
            </Row>
          )}
          {!sidebarItemPair?.readOnly && (
            <div className={'case-save-button'}>
              <Button
                label={'Spremi'}
                size={'lg'}
                disabled={!formik.dirty || !formik.isValid}
                isLoading={isCaseSegmentsSaving}
                color={'info'}
                onClick={() => formik.handleSubmit()}
              />
            </div>
          )}
        </FormikProvider>
      )}
    </>
  );
};

export default CaseSegment;
